import type { ControllableByAI } from "../interfaces";
import type { PhysicalThingWithHp } from "../physicalThingWithHp";
import { BasicAI } from "./basicAI";
import { findSidestepTowards } from "./movement";

export class ToxicSlugAI extends BasicAI {
	constructor(actor: ControllableByAI) {
		super(actor);
		// 2x the standard aggro
		this.aggroDistanceReachable *= 2;
		this.aggroDistanceRadius *= 2;
	}

	// Rolls downhill on the player distance map (no doors, no flying).
	protected override moveTowardsTarget(target: PhysicalThingWithHp): boolean {
		const actorXY = this.actor.getXY();
		if (target.xy.isInSquareRadius(actorXY, 1)) return true;

		const distanceMap = this.getDistanceMapToPlayer();
		if (!distanceMap) return false;

		const path = distanceMap.rollDownhill(actorXY);
		if (path.length === 0) return false;

		let nextStep = path[0];
		if (!this.actor.canMoveTo(nextStep)) {
			const sidestep = findSidestepTowards(actorXY, nextStep, target.xy, (n) => this.actor.canMoveTo(n));
			if (sidestep === null) return false;
			nextStep = sidestep;
		}
		this.moveActorTo(nextStep);
		return true;
	}
}
